export type RouteId =
  | "dashboard"
  | "board"
  | "path"
  | "timeline"
  | "pipeline"
  | "channels"
  | "contacts"
  | "scorecard"
  | "checklist"
  | "assets";

export interface RouteConfig {
  id: RouteId;
  path: string;
  label: string;
  iconName: string; // HugeIcon name for NavRail
}

export const routes: RouteConfig[] = [
  { id: "dashboard", path: "#/dashboard", label: "Command Center", iconName: "Home01Icon" },
  { id: "board", path: "#/board", label: "Control Board", iconName: "TaskDaily02Icon" },
  { id: "path", path: "#/path", label: "Runbook Diario", iconName: "Route01Icon" },
  { id: "timeline", path: "#/timeline", label: "Timeline Maestro", iconName: "Calendar03Icon" },
  { id: "pipeline", path: "#/pipeline", label: "Revenue Pipeline", iconName: "Target02Icon" },
  { id: "channels", path: "#/channels", label: "Distribution Ops", iconName: "Megaphone01Icon" },
  { id: "contacts", path: "#/contacts", label: "Contact Ops", iconName: "UserMultiple02Icon" },
  { id: "scorecard", path: "#/scorecard", label: "Revenue Scorecard", iconName: "ChartLineData02Icon" },
  { id: "checklist", path: "#/checklist", label: "Daily Ops Checklist", iconName: "CheckListIcon" },
  { id: "assets", path: "#/assets", label: "Assets", iconName: "Folder01Icon" },
];

export const DEFAULT_ROUTE: RouteId = "dashboard";

/** Route IDs that render as tabs inside the unified Work Board page */
export const WORK_BOARD_ROUTES: RouteId[] = ["board", "path", "timeline", "checklist", "pipeline"];

export function isWorkBoardRoute(route: RouteId): boolean {
  return WORK_BOARD_ROUTES.includes(route);
}

export function hashToRouteId(hash: string): RouteId {
  const match = routes.find((r) => r.path === hash);
  return match?.id ?? DEFAULT_ROUTE;
}
